import React from 'react';
import './App.css';
import Route from './app/route';
import 'semantic-ui-css/semantic.min.css'

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
function App() {
  return (
      <LocalizationProvider dateAdapter={AdapterMoment}>
          <Route />
      </LocalizationProvider>
  );
}

export default App;
